/**
 * Token provider for Axios requests.
 * Set at app init with the auth service's getToken function (e.g. Cognito).
 */
let tokenGetter: (() => Promise<string | undefined>) | null = null;

export function setTokenGetter(getter: () => Promise<string | undefined>): void {
    tokenGetter = getter;
}

export async function getToken(): Promise<string | undefined> { // skipcq: JS-0116
    return tokenGetter ? tokenGetter() : undefined;
}
